export default __webpack_public_path__ + "static/loading-crop-004174053a2356e379ddbb23dda42c2d.gif";